import useTranslation from 'next-translate/useTranslation'
import React from 'react'

import { LabelWithCheck } from '@/components/LabelWithCheck'
import { casavoAdvantagesFor } from '@/containers/ListingDetail/CasavoAdvantage'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { ListingCate } from '@/page-commons/listingBySlug'

import CasavoAssistantPhone from './CasavoAssistantPhone'
import CasavoPropertyTitle from './CasavoPropertyTitle'
import { casavoPropertyTitle } from './styles.css'

type Props = {
  listing: ListingCate
}

const FormInfoCasavo: React.FC<Props> = ({ listing }) => {
  const { t } = useTranslation()

  const advantages = casavoAdvantagesFor(listing)

  const italianListing = listing.country === 'italy'

  return (
    <div
      className={sprinkles({
        display: 'flex',
        flexDirection: 'column',
        margin: '0 auto',
        marginBottom: '2xl',
        paddingLeft: '2xl',
        paddingRight: '2xl',
      })}
    >
      <div
        className={sprinkles({
          display: 'flex',
          gap: 'l',
          justifyContent: 'space-around',
          margin: '0 auto',
          paddingLeft: '2xl',
          paddingRight: '2xl',
        })}
      >
        <div className={sprinkles({ minWidth: italianListing ? 'initial' : '50%' })}>
          <CasavoPropertyTitle className={casavoPropertyTitle} titles={listing.detail?.titles} />
        </div>
        {!italianListing && (
          <div className={sprinkles({ minWidth: '50%' })}>
            <CasavoAssistantPhone
              isDesktop
              className={casavoPropertyTitle}
              number={listing.contactInfo.telephoneNumberContact}
            />
          </div>
        )}
      </div>
      <ul className={sprinkles({ columns: 2, gap: 'xl', paddingX: 'xl' })}>
        {advantages.map((a) => (
          <li key={a.titleTranslationKey}>
            <LabelWithCheck>{t(a.titleTranslationKey)}</LabelWithCheck>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default FormInfoCasavo
